import { HttpClient } from "@angular/common/http";
import { Injectable, OnDestroy } from "@angular/core";
import { Store } from "@ngrx/store";
import { Observable, Subscription } from "rxjs";
import { tap } from "rxjs/operators";
import { environment } from "src/environments/environment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { ApiVersion } from "src/model/interface/api-version";
import { AppConfiguration } from "src/model/interface/app-configuration";
import {
  clientSettingsSetApplicationThemeAction,
  clientSettingsSetDigitalPlaceFlagAction,
} from "src/state/actions/client-settings.actions";

@Injectable({
  providedIn: "root",
})
export class UploadFileService implements OnDestroy {
  private _logContext: string = "UploadFile.service";

  private _translateSubscription: Subscription = null;

  _eventSubscriptions: Array<Subscription> = null;

  constructor() { }

  ngOnDestroy() { }

  /**
   *  Read the file in chunk considering file sizes, then return the full data object
   * @param file  The file to read
   * @returns
   */
  public async readFileAsync(file: File): Promise<string> {
    if (!file) return Promise.resolve(null);

    const chunkSize: number = 1024 * 1024;
    const fileSize: number = file.size;
    let offset: number = 0;
    const chunks: number[][] = [];

    while (offset < fileSize) {
      const chunk: Blob = file.slice(offset, offset + chunkSize);
      const reader: FileReader = new FileReader();

      const chunkPromise: Promise<Array<number>> = new Promise<Array<number>>(
        (resolve, reject) => {
          reader.onload = (e) => {
            const buffer = new Uint8Array(reader.result as ArrayBuffer);
            resolve(Array.from(buffer));
          };
          reader.onerror = (e) => reject(reader.error);
        }
      );

      reader.readAsArrayBuffer(chunk);
      chunks.push(await chunkPromise);
      offset += chunkSize;
    }

    const dataObject = {
      type: "Buffer",
      data: chunks.reduce((acc, val) => acc.concat(val), []),
    };

    return JSON.stringify(dataObject);
  }
}
